import routeName from '@/router/constant';
import { guideRoutes } from '@/utils/guideRoutes';

const path = 'enotify';
const code = '820';

// 無天版
export const eNotify = [
    {
        path: path,
        name: routeName.ENOTIFY,
        component: () => import('@/views/eNotify/landingPage/Index.vue'),
        meta: {
            auth: false,
            metaTitle: '申請電子通知單-',
            pageTitle: '申請電子通知單服務-',
            code,
        },
    },
    {
        path: `${path}-login`,
        name: routeName.ENOTIFY_LOGIN,
        component: () => import('@/views/eNotify/login/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '申請電子通知單',
            pageTitle: '申請電子通知單服務',
            unableBack: true,
            backPage: routeName.ENOTIFY,
            code,
        },
    },
    // {
    //     path: `${path}-over-year-limit`,
    //     name: routeName.ENOTIFY_OVER_YEAR_LIMIT,
    //     component: () => import('@/views/eNotify/overYearLimit/Index.vue'),
    //     meta: {
    //         auth: true,
    //         metaTitle: '申請電子通知單',
    //         pageTitle: '申請電子通知單服務',
    //         unableBack: true,
    //         backPage: routeName.ENOTIFY,
    //         code,
    //     },
    //     beforeEnter: (to, from, next) => {
    //         const whiteList = [routeName.ENOTIFY_LOGIN, routeName.REDIRECT_ACCOUNT];
    //         const guideRoute = guideRoutes(from, whiteList, true);
    //         next(guideRoute);
    //     },
    // },
    // {
    //     path: `${path}-over-year-otp`,
    //     name: routeName.ENOTIFY_OVER_YEAR_OTP,
    //     component: () => import('@/views/eNotify/overYearOtp/Index.vue'),
    //     meta: {
    //         auth: true,
    //         metaTitle: '申請電子通知單',
    //         pageTitle: '申請電子通知單服務',
    //         unableBack: true,
    //         backPage: routeName.ENOTIFY,
    //         code,
    //     },
    //     beforeEnter: (to, from, next) => {
    //         const whiteList = [routeName.ENOTIFY_OVER_YEAR_LIMIT];
    //         const guideRoute = guideRoutes(from, whiteList, false);
    //         next(guideRoute);
    //     },
    // },
];
// 有天版與步驟圖
export const eNotifyStep = [
    {
        path: `${path}-select-email`,
        name: routeName.ENOTIFY_SELECT_EMAIL,
        component: () => import('@/views/eNotify/selectEmail/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '申請電子通知單',
            leaveAlert: true,
            pageTitle: '申請電子通知單服務',
            unableBack: true,
            backPage: routeName.ENOTIFY,
            code,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.ENOTIFY, routeName.ENOTIFY_LOGIN, routeName.REDIRECT_ACCOUNT];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
    {
        path: `${path}-OTP`,
        name: routeName.OTP,
        component: () => import('@/views/otp/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '動態密碼驗證',
            leaveAlert: true,
            pageTitle: '請輸入動態密碼',
            unableBack: true,
            backPage: routeName.ENOTIFY,
            code,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.ENOTIFY_SELECT_EMAIL];
            const guideRoute = guideRoutes(from, whiteList, false);
            next(guideRoute);
        },
    },
    {
        path: `${path}-register`,
        name: routeName.ENOTIFY_REGISTER,
        component: () => import('@/views/eNotify/setAccount/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '設定使用者代碼及密碼',
            leaveAlert: true,
            pageTitle: '請設定使用者代碼及密碼',
            unableBack: true,
            backPage: routeName.ENOTIFY,
            code,
        },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.OTP];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    },
];
